export default function Hero() {
  const scrollToContact = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d36e2c7818a555aff3a8e95f93723be9.jpg"
          alt="Amazon自動化の背景"
          className="w-full h-full object-cover object-center"
        />
      </div>
      
      {/* 明るいオーバーレイ */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/70"></div>
      
      {/* 装飾的な要素 */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 max-w-[1400px] mx-auto px-8 py-32 text-center w-full">
        <div className="mb-8">
          <span className="inline-block bg-primary/10 text-primary px-6 py-2 rounded-full text-sm font-bold border border-primary/20">
            Amazon運営の最適化
          </span>
        </div>
        
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-gray-900 mb-8 leading-tight">
          Amazon自動化の<br />
          <span className="text-primary">本質</span>
        </h1>
        
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white/80 backdrop-blur-sm border border-gray-200 rounded-2xl p-8 lg:p-12 shadow-xl">
            <p className="text-2xl lg:text-3xl text-gray-800 font-bold leading-relaxed mb-6">
              出品・価格・在庫・利益・広告を
            </p>
            <p className="text-3xl lg:text-4xl text-primary font-black leading-relaxed">
              "最適状態に保つ仕組み"を作ること
            </p>
          </div>
        </div>
        
        <div className="max-w-3xl mx-auto mb-12">
          <div className="bg-white/70 backdrop-blur-sm border border-gray-200 rounded-xl p-6 shadow-lg">
            <p className="text-xl text-gray-700 leading-relaxed">
              Amazonは<strong className="text-primary">価格競争・在庫評価・アルゴリズム依存</strong>の市場。<br />
              人力運用では競争力を維持することが困難です。
            </p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-primary text-white px-10 py-5 rounded-lg font-bold text-lg hover:bg-primary-dark transition-all hover:shadow-lg inline-flex items-center gap-3 whitespace-nowrap cursor-pointer group"
          >
            無料相談を申し込む
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </button>
          
          <button
            onClick={() => {
              const element = document.getElementById('business-map');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-gray-900 text-white border-2 border-gray-900 px-10 py-5 rounded-lg font-bold text-lg hover:bg-gray-800 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            詳しく見る
            <i className="ri-arrow-down-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
